import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import ModelList from "./ModelList";
import ModelView from "./ModelView";
import useGlobalState from "../../Context";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  ModelListingService,
  brandListingOnSelectedBrickService,
  brickListingOnSelectedBrandService,
  ModelListingOnSearchService,
  CategoryListOnSelectedBrandService,
  DownloadModelsService,
} from "../../services/ModelViewService";
import {
  BrickListingWithOrWithoutFamilyId,
  FamilyListingService,
  AllBrandListingService,
} from "../../services/MasterDataManagementService";
import {
  setModelSearchBrand,
  setModelSearchBrick,
  setModelSearchModel
} from "../../reducer/action";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ADD_MODAL_VALIDATIONS } from "../../utils/Validation";

const ModelSearch = () => {
  const [brandSearch, setBrandSearch] = useState(null);
  const [brickSearch, setBrickSearch] = useState(null);
  const { showNotification } = useNotificationContext();
  // const [tableLoader, setTableLoader] = useState(false);
  const { setLoading } = useLoading();
  const [modelRecords, setModelRecords] = useState([]);
  const [totalElements, setTotalElements] = useState(0);
  const [brickList, setBrickList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [brandListOnBrickId, setBrandListOnBrickId] = useState([]);
  const [brickListOnBrandId, setBrickListOnBrandId] = useState([]);
  const [categoryListOnBrandId, setCategoryListOnBrandId] = useState([]);
  const [_categoryListOnBrandId, _setCategoryListOnBrandId] = useState([]);
  const [productFamilyList, setProductFamilyList] = useState([]);
  const [noRecord, setNoRecord] = useState(false);
  const [formData, setFormData] = useState({});
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const [disableFilterButton, setdisableFilterButton] = useState(true);
  const [disableDownloadButton, setDisableDownloadButton] = useState(true);
  const [searchedRows, setSearchedRows] = useState(modelRecords);
  const [searchModelNameValue, setSearchModelNameValue] = useState("");
  const [nameSearch, setNameSearch] = useState("");
  const [disableUpdateButton, setDisbaleUpdateButton] = useState(true);
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selected, setSelected] = useState([]);
  // const auth = JSON.parse(localStorage.getItem("SPMS_INTERNAL_STATE"));
  const [{ auth }, dispatch] = useGlobalState();
  const loginUserType = auth.ldapParam.userType;
  
  const formOption = {
    resolver: yupResolver(ADD_MODAL_VALIDATIONS),
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    resetField
    ,getValues
  } = useForm(formOption);

  useEffect(() => {
    fetchModelDetails("modelName", false);
    fetchBrandListOnSelectedBrick();
    fetchBrickListOnSelectedBrand();
    dispatch(setModelSearchBrand(null));
    dispatch(setModelSearchBrick(null));
    dispatch(setModelSearchModel(null))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const selectedRows =
      modelRecords &&
      modelRecords.filter((row) =>
        row.modelName.toUpperCase().includes(nameSearch.toUpperCase())
      );
    setSearchedRows(selectedRows);
  }, [nameSearch, modelRecords]);

  const fetchModelDetails = async (sortBy, isAsc,brandSearch,brickSearch,searchModelNameValue,paginationObject) => {
    try {
      setLoading(true);
      const modelRequestObj = {
        modelSearchParam: {
          brandId: brandSearch ? brandSearch : null,
          brickId: brickSearch ? brickSearch : null,
          modelName: searchModelNameValue ? searchModelNameValue.trim() : null,
          active: loginUserType === "Main Admin" ? 2 : 0,
        },
       
        modelPage: {
          pageNumber: paginationObject?.pageNumber ?? 0,
          pageSize: paginationObject?.pageSize ?? 10,
          sortDirection: isAsc ? "DESC" : "ASC",
          sortBy: sortBy,
        },
      };
      const res = await ModelListingService(modelRequestObj);
      if (res.statusCode === 6) {
        if (res.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setModelRecords(res.data.content);
        setTotalElements(res.data.totalElements);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleTableChanges = async (
    paginationValues,
    isUpdate,
    sortValue,
    orderBy,
    brandSearch,brickSearch,searchModelNameValue
  ) => {
    try {
      setLoading(true);
      const modelRequestObj = {
        modelSearchParam: {
          brandId: brandSearch ? brandSearch : null,
          brickId: brickSearch ? brickSearch : null,
          modelName: searchModelNameValue ? searchModelNameValue.trim() : null,
          active: loginUserType === "Main Admin" ? 2 : 0,
        },
        modelPage: {
          pageNumber: paginationValues?.pageNumber ?? 0,
          pageSize: paginationValues?.pageSize ?? 10,
          sortDirection: sortValue === null ? "DESC" : sortValue,
          sortBy: orderBy,
        },
      };
      
      // setTableLoader(true);
      const response = await ModelListingService(modelRequestObj);

      if (response.statusCode === 6) {
        if (isUpdate) {
          setModelRecords([...modelRecords, ...response.data.content]);
        } else {
          setModelRecords(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
      // setTableLoader(false);
    }
  };

  const fetchBrickListWithorWithoutFamily = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 10,
        filterSearch: null,
        active: 0,
        sortDirection: "ASC",
        sortBy: "brickId",
        productFamilyId: id ? id : 0,
      };
      const brickListingResponse = await BrickListingWithOrWithoutFamilyId(obj);
      if (brickListingResponse.statusCode === 6) {
        setBrickList(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchCategoryListOnSelectedBrand = async (id) => {
    try {
      const response = await CategoryListOnSelectedBrandService(id);
      if (response.statusCode === 6) {
        setCategoryListOnBrandId(response.data);
        //_setCategoryListOnBrandId(response.data);  
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrandsList = async () => {
    try {
      setLoading(true);
      const brandListingResponse = await AllBrandListingService();
      if (brandListingResponse.statusCode === 6) {
        setBrandList(brandListingResponse.data);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
      // setTotalElements(brandListingResponse.totalElements);
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchBrandListOnSelectedBrick = async (id) => {
    try {
      const brandListingResponse = await brandListingOnSelectedBrickService(id);
      if (brandListingResponse.statusCode === 6) {
        setBrandListOnBrickId(brandListingResponse.data);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrickListOnSelectedBrand = async (id) => {
    try {
      const brickListingResponse = await brickListingOnSelectedBrandService(id);
      if (brickListingResponse.statusCode === 6) {
        // fetchBrandListOnSelectedBrick();
        setBrickListOnBrandId(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchProductFamilyList = async (id) => {
    try {
      const obj = {
        pageNumber: 0,
        pageSize: 10,
        filterSearch: null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        categoryId: id ? id : null,
        sortDirection: "DESC",
        sortBy: "productFamilyName",
      };
      const familyListingResponse = await FamilyListingService(obj);
      if (familyListingResponse.statusCode === 6) {
        setProductFamilyList(familyListingResponse.data);
      } else {
        showNotification("Error", familyListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const onSearchModelList = async (values) => {
    try {
      setLoading(true);
      const modelRequestObj = {
        brandId: values?.brandId ?? null,
        brickId: values?.brickId ?? null,
        modelName: values?.modelName ?? null,
        active: loginUserType === "Main Admin" ? 2 : 0,
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: "ASC",
        sortBy: "modelName",
      };
      const modelListingResponse = await ModelListingOnSearchService(
        modelRequestObj
      );

      if (modelListingResponse.statusCode === 6) {
        if (modelListingResponse.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        setModelRecords(modelListingResponse.data.content);
        setTotalElements(modelListingResponse.data.totalElements);
        return modelListingResponse.data.totalElements;
      } else {
        showNotification("Error", modelListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const downloadModelDetails = async (values) => {
    try {
      setLoading(true);
      const obj = {
        brandId: values?.brandId ?? null,
        brickId: values?.brickId ?? null,
        modelName: values?.modelName ?? null,
        active: values?.active,
      };
      const response = await DownloadModelsService(obj);
      return response;
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const searchOnClick = async (modelName,requestObject) => {
    try {
     
      setLoading(true);
      const modelRequestObj = {
        brandId: brandSearch,
        brickId: brickSearch,
        modelName: modelName.trim(),
        active: true,
        pageSize:  requestObject?.pageSize??10,
        pageNumber: requestObject?.pageNumber??0,
       
      };
     const responseCount = await onSearchModelList(modelRequestObj);
      if (responseCount > 0) {
        setDisableDownloadButton(false);
      } else {
        setDisableDownloadButton(true);
      }
      setPage(0);
      setMaxPage(0);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }

    // setSearchwith(modelName);
    // setNameSearch(searchModelNameValue);
  };

  const onBrandClick = (id) => {
    setBrandSearch(id);
    fetchBrickListOnSelectedBrand(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const onClearClick = async (paginationObject) => {
    setValue("brandId", "");
    reset();
    setSearchModelNameValue("");
    setBrandSearch(null);
    setBrickSearch(null);
    setDisableSearchButton(true);
    setdisableFilterButton(true);
    setDisableDownloadButton(true);
    setSearchedRows([]);
   
    const paginationData= {
      pageNumber: paginationObject?.pageNumber??  0,
      pageSize:  paginationObject ?. pageSize ??  10,
    };
    await fetchModelDetails("modelName", false,null, null, null, paginationData);
    
    await fetchBrandsList();
    await fetchBrickListOnSelectedBrand();
    await fetchBrandListOnSelectedBrick();
    setPage(0);
    setMaxPage(0);
    // setRowsPerPage(10);
  };

  const onBrickClick = (id) => {
    setBrickSearch(id);
    fetchBrandListOnSelectedBrick(id);
    setDisableSearchButton(false);
    setdisableFilterButton(false);
  };

  const handleActiveChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
    if (newSelected.length !== 0) {
      setDisbaleUpdateButton(false);
    } else {
      setDisbaleUpdateButton(true);
    }
    const newSearchedRow = modelRecords?.map((currentRow) => {
      if (currentRow.modelId === id) {
        return {
          ...currentRow,
          isActive: event.target.checked,
        };
      }
      return currentRow;
    });
    setModelRecords(newSearchedRow);
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <ModelList
            getValues = {getValues}
              onBrandClick={onBrandClick}
              onBrickClick={onBrickClick}
              brandSearch={brandSearch}
              brickSearch={brickSearch}
              setDisableSearchButton={setDisableSearchButton}
              setdisableFilterButton={setdisableFilterButton}
              searchedRows={searchedRows}
              reset={reset}
              formData={formData}
              setFormData={setFormData}
              setSearchedRows={setSearchedRows}
              setDisableDownloadButton={setDisableDownloadButton}
              disableFilterButton={disableFilterButton}
              onClearClick={onClearClick}
              disableDownloadButton={disableDownloadButton}
              disableSearchButton={disableSearchButton}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              searchModelNameValue={searchModelNameValue}
              setSearchModelNameValue={setSearchModelNameValue}
              fetchCategoryListOnSelectedBrand={
                fetchCategoryListOnSelectedBrand
              }
              downloadModelDetails={downloadModelDetails}
              onSearchModelList={onSearchModelList}
              fetchProductFamilyList={fetchProductFamilyList}
              fetchBrickListWithorWithoutFamily={
                fetchBrickListWithorWithoutFamily
              }
              handleTableChanges={handleTableChanges}
              brandList={brandList}
              brickList={brickList}
              totalElements={totalElements}
              brandListOnBrickId={brandListOnBrickId}
              brickListOnBrandId={brickListOnBrandId}
              categoryListOnBrandId={categoryListOnBrandId}
              productFamilyList={productFamilyList}
              noRecord={noRecord}
              page={page}
              maxPage={maxPage}
              searchOnClick={searchOnClick}
              fetchBrandsList={fetchBrandsList}
              setPage={setPage}
              setMaxPage={setMaxPage}
              setLoading={setLoading}
              setModelRecords={setModelRecords}
              handleActiveChange={handleActiveChange}
              disableUpdateButton={disableUpdateButton}
              selected={selected}
              setSelected={setSelected}
              setDisbaleUpdateButton={setDisbaleUpdateButton}
              showNotification={showNotification}
              modelRecords={modelRecords}
              fetchModelDetails={fetchModelDetails}
              setValue = {setValue}
              setCategoryListOnBrandId = {setCategoryListOnBrandId}
              rowsPerPage = {rowsPerPage}
              setRowsPerPage = {setRowsPerPage}
              // _categoryListOnBrandId = {_categoryListOnBrandId}
            />     
          }  
        />
        <Route path="model-view" element={<ModelView onClearClick= {fetchModelDetails} />}></Route>
      </Routes>
    </>
  );
};

export default ModelSearch;
